<template>
    <div class="search-block w-[90%] mx-auto">
        <div class="flex justify-between mt-2">
            <div class="search-bar flex items-center h-[38px] w-[228px] pl-[10px]  border-[1px] border-rose-emb bg-opacity-30 px-[5px] rounded-[6px]">
                <img src="@/assets/icons/magnify_icon.svg" class="w-[16px] h-[16px] ml-[6px]">
                <input v-model="search" class="text-gray-emb bg-transparent bg-opacity-30 ml-[6px] text-[13px] rounded-[6px] px-1 placeholder:text-rose-emb outline-none w-[250px]" placeholder="пошук..." type="text">
            </div>
            <div class="filter flex items-center">
                <div class="flex w-[110px] justify-between mr-[130px] text-rose-emb">
                    <img @click="prevPage" src="@/assets/icons/left_arrow.svg" class="cursor-pointer">
                    <div class="flex mx-[20px]">Сторінка: <input v-model="page" type="number" class="bg-transparent text-end mx-2 w-[5ch] outline-none px-1"> / <span class="ml-[10px]">{{ maxPage }}</span></div>
                    <img @click="nextPage" src="@/assets/icons/right_arrow.svg" class="cursor-pointer">
                </div>
                <button class="bg-green-emb hover:bg-[#6BA292d6] h-[38px] w-[228px] text-gray-emb px-4 py-[6px] text-[14px] rounded-[6px]" @click="$emit('addStudent')">Додати</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, watch } from 'vue'

    export default {
        name: 'menu-bar',

        emits: ['update:modelValue', 'startFilter'],

        props: {
            modelValue: {
                type: String,
                default: ''
            },
            page: {
                type: Number,
                default: 1
            },
            maxPage: {
                type: Number,
                default: 1
            }
        },

        setup(props, { emit }) {
            const search = ref(props.modelValue)
            const page = ref(props.page) 

            const prevPage = () => {
                page.value > 1 ? page.value-- : page.value = 1
            }

            const nextPage = () => {
                page.value += 1
            }

            watch(search, (value) => {
                emit('update:modelValue', value)
                emit('startFilter')
            })

            watch(page, (value) => {
                if (value >= props.maxPage) {
                    page.value = props.maxPage
                } else if (value <= 1 && value != '') {
                    page.value = 1
                } else if (value == ''){
                    return
                }
                emit('update:page', value)
                emit('startFilter')
            })

            return {
                search,
                page,
                prevPage,
                nextPage
            }
        }
    }
</script>

<style lang="scss" scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

</style>
